import * as React from 'react';
import { ISeedProduct, ISeedIcon, IDocument } from 'src/infrastructure/interfaces';
import './TypeSeedIcons.css';

export interface ITypeSeedIcons {
  product: ISeedProduct;
  document?: IDocument;
}

export default class TypeSeedIcons extends React.Component<ITypeSeedIcons> {

  render() {
    const docType = this.props.document ? this.props.document.type : "";

    const icons = this.props.product.icons.map((icon: ISeedIcon) => ({
      src: icon.src,
      name: icon.name,
    }));
    return (
      <div className={`${docType} seed-icons seed-icons-${icons.length}`}>
        {icons.map((icon, index) => (
          <div className={`${docType} seed-icon seed-icon-${index + 1}`} key={index}>
            <img src={icon.src} alt={`${icon.name}`} />
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Products/components/TypeSeedIcons.tsx